/* Home 3.2: the collection's second-photo behavior, without density preferences. */
(()=>{
'use strict';
const root=document.querySelector('[data-iu-home-recent]');if(!root)return;
function indicatePhotos(link){
 if(link.querySelector('.iu-st-photo-dots'))return;
 const dots=document.createElement('span');dots.className='iu-st-photo-dots';dots.setAttribute('aria-hidden','true');
 dots.append(document.createElement('i'),document.createElement('i'));link.append(dots);
}
function load(link){const img=link.querySelector('[data-secondary-src]');if(!img||img.getAttribute('src'))return;
 img.onload=()=>{if(img.naturalWidth>0){link.classList.add('iu-st-second-ready');indicatePhotos(link);}};
 img.onerror=()=>{link.classList.remove('iu-st-has-second','iu-st-photo-selected','iu-st-second-ready');link.dataset.secondaryFailed='true';link.removeAttribute('aria-label');link.querySelector('.iu-st-photo-dots')?.remove();img.remove();};
 if(img.dataset.secondarySrcset)img.srcset=img.dataset.secondarySrcset;
 img.src=img.dataset.secondarySrc;
}
let observer;
function mount(){observer?.disconnect();if('IntersectionObserver'in window){observer=new IntersectionObserver(entries=>{for(const e of entries)if(e.isIntersecting){load(e.target);observer.unobserve(e.target);}},{rootMargin:'160px'});root.querySelectorAll('.iu-st-has-second').forEach(link=>observer.observe(link));}}
root.addEventListener('iu:cards-rendered',mount);mount();
root.addEventListener('pointerover',e=>{const link=e.target.closest('.iu-st-has-second');if(link)load(link);});
root.addEventListener('focusin',e=>{const link=e.target.closest('.iu-st-has-second');if(link)load(link);});
// 4.1.3: touch swipes preview photos; ordinary taps remain native product links.
let gesture=null,swipeClick=null;
document.addEventListener('pointerdown',e=>{
 swipeClick=null;
 if(e.pointerType==='touch'&&!e.isPrimary)gesture=null;
},{capture:true,passive:true});
root.addEventListener('pointerdown',e=>{
 if(e.pointerType!=='touch'||!e.isPrimary){gesture=null;return;}
 const link=e.target.closest('.iu-st-has-second');
 if(!link||!link.classList.contains('iu-st-second-ready'))return;
 gesture={link,id:e.pointerId,x:e.clientX,y:e.clientY,axis:null};
},{passive:true});
root.addEventListener('pointermove',e=>{
 if(!gesture||e.pointerId!==gesture.id||gesture.axis)return;
 const x=Math.abs(e.clientX-gesture.x),y=Math.abs(e.clientY-gesture.y);
 if(Math.max(x,y)<12)return;
 // Lock vertically unless the initial movement clearly intends a horizontal swipe.
 gesture.axis=x>y*1.3?'x':'y';
},{passive:true});
root.addEventListener('pointerup',e=>{
 const current=gesture;if(!current||e.pointerId!==current.id)return;gesture=null;
 const x=e.clientX-current.x,y=e.clientY-current.y;
 if(current.axis==='y'||Math.abs(x)<32||Math.abs(x)<=Math.abs(y)*1.3)return;
 if(!current.link.isConnected||!current.link.classList.contains('iu-st-second-ready'))return;
 current.link.classList.toggle('iu-st-photo-selected',x<0);
 // A browser may emit click after a swipe. Consume only that gesture's click.
 swipeClick={link:current.link,id:current.id,until:Date.now()+700};
},{passive:true});
root.addEventListener('pointercancel',e=>{if(gesture?.id===e.pointerId)gesture=null;},{passive:true});
root.addEventListener('lostpointercapture',e=>{if(gesture?.id===e.pointerId)gesture=null;},{passive:true});
document.addEventListener('visibilitychange',()=>{if(document.hidden){gesture=null;swipeClick=null;}});
root.addEventListener('click',e=>{
 if(!swipeClick||e.detail===0||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
 if(Date.now()>swipeClick.until){swipeClick=null;return;}
 if(e.target.closest('.iu-st-image')!==swipeClick.link)return;
 if(e.pointerId>0&&e.pointerId!==swipeClick.id)return;
 swipeClick=null;e.preventDefault();e.stopPropagation();
},true);
root.addEventListener('iu:cards-rendered',()=>{gesture=null;swipeClick=null;});

})();
